<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body
  >
    <el-form
      :model="form"
      :rules="rules"
      hide-required-asterisk
      ref="form"

      label-position="left"
    >
      <el-form-item prop="dspId">
        <template v-slot:label>
          <div class="form-item__label">所属DSP</div>
        </template>
        <search-dsp-select
          v-model="form.dspId"
          :dspType="null"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item prop="dspSlotName">
        <template v-slot:label>
          <div class="form-item__label">广告位名称</div>
        </template>
        <el-input
          v-model="form.dspSlotName"

          placeholder="请输入广告位名称"
        />
      </el-form-item>
      <el-form-item prop="slotTypeId">
        <template v-slot:label>
          <div class="form-item__label">广告位类型</div>
        </template>
        <search-slot-type-select
          v-model="form.slotTypeId"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item prop="subjectId">
        <template v-slot:label>
          <div class="form-item_label">主体</div>
        </template>
        <el-select
          v-model="form.subjectId"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option
            v-for="item in subjectList"
            :label="item.subjectName"
            :value="item.subjectId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="90px">
        <template v-slot:label>
          <div>设备类型：</div>
        </template>
        <el-radio
          v-for="item in appTypeList"
          v-model="form.appType"
          :label="item.value"
          :key="item.value"
        >{{ item.label }}
        </el-radio
        >
      </el-form-item>
      <el-form-item label-width="90px">
        <template v-slot:label>
          <div>预算类型：</div>
        </template>
        <el-radio
          v-for="item in billingTypeList"
          v-model="form.billingType"
          :label="item.value"
          :key="item.value"
        >{{ item.label }}
        </el-radio
        >
      </el-form-item>
      <el-form-item label-width="90px">
        <template v-slot:label>
          <div>合作模式：</div>
        </template>
        <el-radio v-model="form.settlementType" :label="2">RTB竞价</el-radio>
        <el-radio v-model="form.settlementType" :label="1">分成</el-radio>
        <el-radio v-model="form.settlementType" :label="0">固价</el-radio>
        <el-input
          v-if="form.settlementType === 0"
          v-model="form.cpmPrice"
          type="number"

          placeholder="请输入固价CPM价格"
        />
      </el-form-item>
      <el-form-item prop="budget">
        <template v-slot:label>
          <div class="form-item__label">上游预算：</div>
        </template>
        <el-checkbox-group
          v-model="form.budget"
          style="width: 100%; display: inline-block"
        >
          <el-checkbox
            v-for="item in budgetList"
            :label="item.budgetId"
            :key="item.budgetId"
          >{{ item.budgetName }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item prop="dspSlotCode">
        <template v-slot:label>
          <div class="form-item__label">广告位Code</div>
        </template>
        <el-input
          v-model="form.dspSlotCode"

          placeholder="请输入广告位Code"
        />
      </el-form-item>
      <el-form-item prop="dspSlotExt">
        <template v-slot:label>
          <div class="form-item__label">扩展字段</div>
        </template>
        <el-input
          v-model="form.dspSlotExt"

          placeholder="请输入扩展字段"
        />
      </el-form-item>
      <el-form-item>
        <div style="line-height: 25px">限制量</div>
        <el-select
          v-model="form.flowType"
          style="width: 20%; margin-right: 5%"

          placeholder="限制类型"
        >
          <el-option
            v-for="item in flowTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="form.flowSize"

          type="number"
          style="width: 75%"
          placeholder="请输入限制量"
        />
      </el-form-item>
      <el-form-item v-if="form.dspId">
        <el-collapse>
          <el-collapse-item title="限制量时段配置" name="1">
            <p :style="totalValue >= 1 ? { color: 'black' } : { color: 'red'}">说明：时段合计不能大于1，0.1 = 10%。,当前数值：{{totalValue}}</p>
            <p>如果选择复选框，则会锁值。不会根据其他文本框输入动态计算。</p>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkList">
              <div class="collapse-item" v-for="item in timePeriodRatio">
                <el-checkbox :label="item.label"></el-checkbox>
                <el-input-number size="small"
                                 :precision="4"
                                 :min="0"
                                 :max="1"
                                 :step="0.01"
                                 v-model="item.value"
                                 @change="handleReqLimitChange(item)">

                </el-input-number>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
      </el-form-item>
      <el-form-item prop="maxQps">
        <template v-slot:label>
          <div class="form-item__label">QPS</div>
        </template>
        <el-input
          v-model="form.maxQps"
          type="number"

          placeholder="请输入QPS"
        />
      </el-form-item>
      <el-form-item prop="routeAddress">
        <template v-slot:label>
          <div class="form-item__label">路由地址</div>
        </template>
        <div>
          <el-select
            v-model="form.routeAddress"
            style="width: 100%"
            filterable
            clearable
            multiple

            placeholder="请选择路由地址"
          >
            <el-option
              v-for="item in routeData"
              :key="item.ip"
              :label="item.name"
              :value="item.ip"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item prop="appName">
        <template v-slot:label>
          <div class="form-item__label">应用名称</div>
        </template>
        <el-input
          v-model="form.appName"

          placeholder="请输入应用名称"
        />
      </el-form-item>

      <el-form-item prop="appBundle">
        <template v-slot:label>
          <div class="form-item__label">应用包名</div>
        </template>
        <el-input
          v-model="form.appBundle"

          placeholder="请输入应用包名"
        />
      </el-form-item>

      <el-form-item prop="appVer">
        <template v-slot:label>
          <div class="form-item__label">应用版本</div>
        </template>
        <el-input
          v-model="form.appVer"

          placeholder="请输入应用版本"
        />
      </el-form-item>

      <el-form-item prop="tag">
        <template v-slot:label>
          <div class="form-item__label">标签</div>
        </template>
        <el-input v-model="form.tag" placeholder="请输入"/>
      </el-form-item>
    </el-form>

    <div style="text-align: right">
      <el-button @click="close">取消</el-button>
      <el-button
        @click="submit"
        type="primary"

        :loading="submitLoading"
      >确定
      </el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import SearchSlotTypeSelect from '@/components/SearchSlotTypeSelect'
import SearchDspSelect from '@/components/SearchDspSelect'

import {getSlotBudget} from '@/api/select'
import {getMasterSubjectInfo} from '@/api/report/dsp'
import {getDspSlot, addDspSlot, updateDspSlot, deleteSlot, getRouteAddress} from '@/api/manage/dsp/ad'
import {appTypeList} from '@/const/app-type'
import {billingTypeList} from '@/const/billing-type'


const form = {
  dspId: undefined,
  dspSlotName: undefined,
  slotTypeId: undefined,
  billingType: 0,
  appType: 1,
  settlementType: 2,
  dspSlotCode: undefined,
  routeAddress: [],
  dspSlotExt: undefined,
  maxQps: undefined,
  cpmPrice: undefined,
  budget: [],
  appName: undefined,
  appBundle: undefined,
  appVer: undefined,
  tag: undefined,
  flowType: 0,
  flowSize: undefined,
  subjectList: []
}

export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    },
    data: Object
  },
  emits: ['submit'],
  components: {
    SearchSlotTypeSelect,
    SearchDspSelect
  },
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        dspId: [{required: true, message: '请选择所属dsp', trigger: 'change'}],
        subjectId: [{required: true, message: '请选择主体', trigger: 'change'}],
        dspSlotName: [{required: true, message: '请输入广告位名称', trigger: 'blur'}],
        slotTypeId: [{required: true, message: '请选择广告位类型', trigger: 'change'}],
        dspSlotCode: [{required: false, message: '请输入广告位Code', trigger: 'blur'}],
        dspSlotExt: [{required: false, message: '请输入扩展字段', trigger: 'blur'}],
        appName: [{required: false, message: '请输入应用名称', trigger: 'blur'}],
        appBundle: [{required: false, message: '请输入应用包名', trigger: 'blur'}],
        appVer: [{required: false, message: '请输入应用版本', trigger: 'blur'}],
        tag: [{required: false, message: '请输入标签', trigger: 'blur'}],
        routeAddress: [{required: false, message: '请选择路由地址', trigger: 'blur'}],
        maxQps: [{required: false, message: '请输入QPS', trigger: 'blur', pattern: /^[0-9]*$/}]
      },
      appTypeList,
      billingTypeList,
      flowTypeList: [
        {label: '空', value: 0},
        {label: '展示', value: 1},
        {label: '请求', value: 2}
      ],
      checkList: ['0点','1点','2点','3点','4点','5点','6点','7点','8点','9点','10点','11点','12点','13点','14点','15点','16点','17点','18点','19点','20点','21点','22点','23点'],
      defaultTimePeriodRatio: [
        {label: '0点', value: 0, oldValue: 0},
        {label: '1点', value: 0, oldValue: 0},
        {label: '2点', value: 0, oldValue: 0},
        {label: '3点', value: 0, oldValue: 0},
        {label: '4点', value: 0, oldValue: 0},
        {label: '5点', value: 0, oldValue: 0},
        {label: '6点', value: 0, oldValue: 0},
        {label: '7点', value: 0, oldValue: 0},
        {label: '8点', value: 0, oldValue: 0},
        {label: '9点', value: 0, oldValue: 0},
        {label: '10点', value: 0, oldValue: 0},
        {label: '11点', value: 0, oldValue: 0},
        {label: '12点', value: 0, oldValue: 0},
        {label: '13点', value: 0, oldValue: 0},
        {label: '14点', value: 0, oldValue: 0},
        {label: '15点', value: 0, oldValue: 0},
        {label: '16点', value: 0, oldValue: 0},
        {label: '17点', value: 0, oldValue: 0},
        {label: '18点', value: 0, oldValue: 0},
        {label: '19点', value: 0, oldValue: 0},
        {label: '20点', value: 0, oldValue: 0},
        {label: '21点', value: 0, oldValue: 0},
        {label: '22点', value: 0, oldValue: 0},
        {label: '23点', value: 0, oldValue: 0}
      ],
      timePeriodRatio: [],
      totalValue: 0,
      slotSizeList: [],
      budgetList: [],
      isAdd: true,
      routeData: [],
      checkAll: false,
      isIndeterminate: true
    }
  },
  created() {
    this.getSubjectInfo()
    this.getSlotBudget()
    this.getRouteAddress()
  },
  computed: {
    dialogTitle() {
      return (this.title ? this.title : '') + (this.isAdd ? '新增' : '编辑')
    }
  },
  methods: {
    init() {
    },
    handleReqLimitChange(item){

      this.$nextTick(() => {
        // 计算当前所有值的总和
       let total = this.timePeriodRatio.reduce((sum, period) => sum + period.value, 0);

        // 检查总和是否超过 1
        if (total.toFixed(4) > 1) {
          const excess = total - 1;

          debugger
          // 计算除当前 item 外所有其他项的总和(没有锁住状态)
          const otherTotalValue = this.timePeriodRatio
            .filter(period => period !== item)
            .filter(period => this.checkList.indexOf(period.label) === -1)
            .reduce((sum, period) => sum + period.oldValue, 0);

          if(otherTotalValue <= 0  || otherTotalValue < excess){
            this.$message.warning("请检查锁定，合计数值已经大于1。无法修改！")
            // 更新旧值
            item.value = item.oldValue

            return
          }

          // 按比例缩小其他项
          this.timePeriodRatio.forEach(period => {
            if (period !== item && this.checkList.indexOf(period.label) === -1) {
              period.value = Math.max(0, period.oldValue - (period.oldValue / otherTotalValue) * excess);
              period.oldValue = period.value
            }
          });
        }
        total = this.timePeriodRatio.reduce((sum, period) => sum + period.value, 0);
        this.totalValue = parseFloat(total.toFixed(4));
        // 更新旧值
        item.oldValue = item.value
      })

    },
    handleCheckAllChange(val) {
      this.checkList = val ? this.timePeriodRatio.map(item=>item.label) : [];
      this.isIndeterminate = false;
    },
    getSubjectInfo() {
      getMasterSubjectInfo().then(res => {
        this.subjectList = res.data
      })
    },
    getSlotBudget() {
      getSlotBudget().then(res => {
        if (res.code === 200) {
          this.budgetList = res.data
        }
      })
    },
    getRouteAddress() {
      getRouteAddress().then(res => {
        if (res.code === 200) {
          this.routeData = res.data
        }
      })
    },
    show(id) {
      this.dialogStatus = true
      if (id) {
        this.getDspSlot(id)
        this.isAdd = false
      }
    },
    computeTotalValue() {
      const total = this.timePeriodRatio.reduce((sum, period) => sum + period.value, 0);
      this.totalValue = parseFloat(total.toFixed(4));
    },
    getDspSlot(id) {
      getDspSlot(id).then(res => {
        if (res.code === 200) {
          this.form = res.data
          this.timePeriodRatio = JSON.parse(JSON.stringify(this.defaultTimePeriodRatio));
          this.form.flowType = res.data.dspFlowType
          this.form.flowSize = res.data.dspFlowSize
          this.form.appType = res.data.appType == 0 ? 4 : res.data.appType
          this.form.budget = (this.form.budget || '').split(',').map(item => {
            return Number(item)
          })
          if (this.form.routeAddress) {
            this.form.routeAddress = this.form.routeAddress.split(',').map(item => {
              return item
            })
          } else {
            this.form.routeAddress = []
          }

          if(res.data.hourProportion){
            let hourProp = res.data.hourProportion.split(',');
            this.timePeriodRatio.forEach((item, i) => {
              item.value = Number(hourProp[i])
              item.oldValue = Number(hourProp[i])
            });
            this.computeTotalValue()
          }

        }
      })
    },
    close() {
      this.dialogStatus = false
      this.reset()
    },
    // handleSlowClose (slotId, index) {
    //   this.$confirm(
    //     '是否删除该媒体？',
    //     '删除确认',
    //     {
    //       confirmButtonText: '确认',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }
    //   ).then(() => {
    //     this.deleteSlot(slotId, index)
    //   }).catch(() => {})
    // },
    deleteSlot(slotId, index) {
      const form = {
        dspSlotId: this.form.dspSlotId,
        slotId
      }
      deleteSlot(form).then(res => {
        if (res.code === 200) {
          this.form.slotFlowList.splice(index, 1)
        }
      }).catch(() => {
        this.$message.error('删除失败')
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid && this.validate()) {
          if (this.form.dspSlotId) {
            this.update(this.normalForm())
          } else {
            this.add(this.normalForm())
          }
        }
      })
    },
    validate() {
      if (this.form.budget.length < 1) {
        this.$message.warning('请选择 预算')
        return false
      }
      if (this.form.settlementType !== 0) {
        this.form.cpmPrice = undefined
      } else {
        this.form.cpmPrice = Number(this.form.cpmPrice)
      }
      if (this.form.routeAddress) {
        let data = ""
        this.form.routeAddress.forEach(item => {
          data = data ? data + ',' + item : item
        });
        this.form.routeAddress = data
      }
      return true
    },
    normalForm() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.budget = form.budget.join(',') || undefined
      form.hourProportion = this.timePeriodRatio.map(item => item.value).join(',') || undefined
      return form
    },
    add(form) {
      this.submitLoading = true
      addDspSlot(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    update(form) {
      this.submitLoading = true
      updateDspSlot(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset() {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select .el-input {
  width: 130px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item {
  display: block;
}

.el-form-item ::v-deep .el-form-item__label {
  float: left;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}

.collapse-item {
  width: 20%;
  float: left;
  margin-right: 5%;
}
</style>
